import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{! template-lint-disable no-bare-strings }}\n<div class=\'footer-print print-only\'>\n  &copy; Fabscale GmbH\n  {{format-date (date/now) (hash formatString=\'yyyy\')}}\n</div>")